import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getItemRackApi,
  saveItemRackApi,
  deleteItemRackApi,
} from "../../apiservice/inventory";

export const fetchRacksList = createAsyncThunk(
  "racks/fetchRacksList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemRackApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createOrUpdateRack = createAsyncThunk(
  "racks/createOrUpdateRack",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveItemRackApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteRack = createAsyncThunk(
  "racks/deleteRack",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteItemRackApi({ id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
